import type { FC } from 'react'
import { TipItem } from './TipItem'
import { QUICK_TIPS, type TabId } from './constants'

interface QuickTipsProps {
  activeTab: string
}

/**
 * Displays contextual quick tips based on the active settings tab
 */
export const QuickTips: FC<QuickTipsProps> = ({ activeTab }) => {
  const tips = QUICK_TIPS[activeTab as TabId] || []

  if (tips.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">
        No tips available for this tab.
      </p>
    )
  }

  return (
    <div className="space-y-3" data-testid="quick-tips-section">
      {tips.map((tip, index) => (
        <TipItem
          key={`${activeTab}-${index}`}
          icon={tip.icon}
          title={tip.title}
          description={tip.description}
          learnMoreContent={tip.learnMoreContent}
          index={index}
        />
      ))}
    </div>
  )
}

export default QuickTips
